<template>
	<div class="page" v-if="page">
		<section class="section">
			<div class="container content is-fullhd">
				<div class="columns">
					<div class="column is-half">
						<div class="box">
							<table class="table is-fullwidth">
								<thead>
									<tr>
										<th class="has-text-right">Week</th>
										<th colspan="2" class="has-text-centered">Points Scored</th>
										<th>Opponent</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in page.schedule">
										<td class="has-text-right">{{ item.week_id }}</td>
										<td
											class="has-text-right"
											:class="{ 'has-text-weight-bold': item.is_winner, 'is-italic': !item.is_complete }"
										>
											{{ item.team1_points }}
										</td>
										<td :class="{ 'has-text-weight-bold': item.is_loser, 'is-italic': !item.is_complete }">
											{{ item.team2_points }}
										</td>
										<td>
											<TeamLink :teamKey="item.team2_key" :teamName="item.team2_name" />
										</td>
										<td>
											<a
												v-if="item.has_details"
												href="#"
												class="effect has-text-weight-semibold"
												@click.prevent="setActiveMatchup(item.week_id)"
												><small>Details</small></a
											>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="column is-half" v-if="focused_matchup">
						<div class="box">
							<table class="table is-fullwidth">
								<thead>
									<tr>
										<th>{{ focused_matchup.team1_name }}</th>
										<th colspan="3" class="has-text-centered">Week {{ focused_matchup.week_id }}</th>
										<th>
											<TeamLink :teamKey="focused_matchup.team2_key" :teamName="focused_matchup.team2_name" />
										</th>
									</tr>
								</thead>
								<tbody>
									<template v-for="roster_position in focused_matchup_roster_positions">
										<tr
											v-for="(player, i) in showBestballPlayers
												? roster_position.players_bestball
												: roster_position.players_actual"
											:class="roster_position.position == 'BN' && i == 0 ? 'thick-line' : ''"
										>
											<td>
												<small>{{ player.team1 ? player.team1.name : "-" }}</small>
											</td>
											<td class="has-text-right">
												<small>{{ player.team1 ? player.team1.points : "0.00" }}</small>
											</td>
											<td class="has-text-centered">
												<small>{{ roster_position.position }}</small>
											</td>
											<td class="has-text-right">
												<small>{{ player.team2 ? player.team2.points : "0.00" }}</small>
											</td>
											<td>
												<small>{{ player.team2 ? player.team2.name : "-" }}</small>
											</td>
										</tr>
									</template>
								</tbody>
								<tfoot>
									<tr>
										<th colspan="2" class="has-text-right">
											<small>{{
												showBestballPlayers
													? focused_matchup.details.team1_points_bestball
													: focused_matchup.team1_points
											}}</small>
										</th>
										<th class="has-text-centered">
											<small>{{ showBestballPlayers ? "BESTBALL*" : "TOTAL" }}</small>
										</th>
										<th colspan="2">
											<small>{{
												showBestballPlayers
													? focused_matchup.details.team2_points_bestball
													: focused_matchup.team2_points
											}}</small>
										</th>
									</tr>
									<tr v-if="!showBestballPlayers">
										<td colspan="2" class="has-text-right">
											<small
												>{{ focused_matchup.details.team1_correct }} ({{
													focused_matchup.details.team1_accuracy
												}})</small
											>
										</td>
										<td class="has-text-centered"><small>ACCURACY*</small></td>
										<td colspan="2">
											<small
												>{{ focused_matchup.details.team2_correct }} ({{
													focused_matchup.details.team2_accuracy
												}})</small
											>
										</td>
									</tr>
								</tfoot>
							</table>

							<div class="buttons is-centered">
								<a href="#" class="button is-primary is-outlined" @click.prevent="toggleBenchPlayers"
									>{{ showBenchPlayers ? "Hide" : "Show" }} Bench</a
								>
								<a href="#" class="button is-primary is-outlined" @click.prevent="toggleBestballPlayers">{{
									showBestballPlayers ? "Show Actual Lineups" : "Switch to BestBall"
								}}</a>
							</div>

							<p>
								<small
									>* Lineup accuracy is how many starting players were the best possible player that could have been
									started to get the most points out of that position.</small
								>
							</p>
							<p>
								<small
									>* Bestball lineups are the best possible players that could have been started from a team's roster to
									get the most points for the week.</small
								>
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<pre>{{ page }}</pre>
	</div>
</template>

<script>
import TeamLink from "@/components/TeamLink"

export default {
	components: {
		TeamLink,
	},
	data() {
		return {
			showBenchPlayers: false,
			showBestballPlayers: false,
		}
	},
	computed: {
		page() {
			return this.$store.getters.activePage
		},
		focused_matchup() {
			return this.$store.getters.activePageScheduleMatchup
		},
		focused_matchup_roster_positions() {
			const focused_matchup = this.focused_matchup

			if (focused_matchup) {
				let roster_positions = focused_matchup.details.roster_positions

				if (!this.showBenchPlayers) {
					roster_positions = roster_positions.filter((x) => Boolean(x.position_type))
				}

				return roster_positions
			}

			return []
		},
	},
	methods: {
		setActiveMatchup(weekId) {
			this.showBenchPlayers = false
			this.showBestballPlayers = false

			this.$store.dispatch("setActivePageScheduleWeekId", weekId)
		},
		toggleBenchPlayers() {
			this.showBenchPlayers = !this.showBenchPlayers
		},
		toggleBestballPlayers() {
			this.showBestballPlayers = !this.showBestballPlayers
		},
	},
	mounted() {
		this.$store.dispatch("setActivePage", "team_schedule")
	},
}
</script>

<style scoped>
.buttons {
	margin-top: 2rem;
}
</style>
